import core, { App } from '@gin-betting/core';

import { ExtendedRouts } from 'app-constants';

const {
    utils: { isOneOfPages },
} = core;

export default function isFavoritePage() {
    return isOneOfPages(
        ([
            ExtendedRouts.FAVORITE_UPCOMING,
            ExtendedRouts.FAVORITE_RESULTS,
            ExtendedRouts.FAVORITE_OUTRIGHTS,
        ] as any) as App.Routes[],
        { exact: true }
    );
}
